<!--
 @description 服务监控-应用详情页-当前告警tab
 @author xiehan
 @date 2018/10/12
-->
<template>
  <div>
    <el-form ref="alarmForm" :model="alarmForm" label-width="80px" :inline="true" class="demo-form-inline">
      <el-form-item :label="$t('serverMonitor.alarmType')" prop="alarmType">
        <g-select v-model="alarmForm.alarmType" :list="select_alarmType" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('serverMonitor.alarmLevel')" prop="alarmLevel">
        <g-select v-model="alarmForm.alarmLevel" :list="select_alarmLevel" :defaultAll="true"></g-select>
      </el-form-item>
      <el-form-item :label="$t('serverMonitor.alarmCode')" prop="alarmCode">
        <el-input v-model="alarmForm.alarmCode"></el-input>
      </el-form-item>
      <el-form-item :label="$t('serverMonitor.alarmName')" prop="alarmName">
        <el-input v-model="alarmForm.alarmName"></el-input>
      </el-form-item>
      <el-form-item :label="$t('serverMonitor.locationInfo')" prop="locationInfo">
        <el-input v-model="alarmForm.locationInfo"></el-input>
      </el-form-item>
      <el-form-item :label="$t('serverMonitor.alarmObject')" prop="alarmObject">
        <el-input v-model="alarmForm.alarmObject"></el-input>
      </el-form-item>
      <el-form-item :label="$t('serverMonitor.alarmAddress')" prop="alarmAddress">
        <el-input v-model="alarmForm.alarmAddress"></el-input>
      </el-form-item>
      <el-form-item :label="$t('serverMonitor.alarmTime')" input-width="auto">
        <el-form-item prop="startTime">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="alarmForm.startTime" type="datetime">
          </el-date-picker>
        </el-form-item>
        <span v-text="$t('common.to')"></span>
        <el-form-item prop="endTime" style="margin-left: 10px">
          <el-date-picker value-format="timestamp" style="width: 180px;" v-model="alarmForm.endTime" type="datetime">
          </el-date-picker>
        </el-form-item>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="searchAlarm" v-g-rac="gRac('alarmQueryCurrent_search')" v-text="$t('common.search')"></el-button>
        <el-button type="primary" @click="handle" v-g-rac="gRac('alarmQueryCurrent_handle')" v-text="$t('serverMonitor.handle')"></el-button>
      </el-form-item>
    </el-form>
    <el-table-extend 
      :data="tData" 
      :head="tableHead" 
      :selection="true" 
      :selectionChange="alarmSelect"
      :currentChange="currentChange"
      :sizeChange="sizeChange"
      border>
    </el-table-extend>
  </div>
</template>

<script>
  import rac from '@/plugins/rac-mixin'
  import dic from '@/components/mixins/dic'
  import table from '@/components/mixins/table'
  import TimeFormat from '@/utils/timeFormat'
  import alarmQueryBiz from '@/logic/intelligentMonitor/alarmQueryBiz'
  export default {
    mixins: [rac, dic, table],
    data () {
      return {
        select_alarmType: {},
        select_alarmLevel: {},
        alarmForm: {
          alarmCode: '',
          alarmName: '',
          locationInfo: '',
          alarmObject: '',
          alarmAddress: '',
          alarmType: '',
          alarmLevel: '',
          startTime: '',
          endTime: ''
        },
        tableHead: [],
        tableSelect: [],
        currentPage: 1,
        perPageCount: 10
      }
    },
    props: ['app', 'group'],
    methods: {
      initTable () {
        this.tableHead = [{
          key: 'alarmCode',
          label: this.$t('serverMonitor.table')['alarmCode'],
          width: '74px'
        }, {
          key: 'alarmName',
          label: this.$t('serverMonitor.table')['alarmName']
        }, {
          key: 'alarmType',
          label: this.$t('serverMonitor.table')['alarmType'],
          formatter: 'Dictionary',
          formatterDic: this.select_alarmType,
          width: '110px'
        }, {
          key: 'alarmObject',
          label: this.$t('serverMonitor.table')['alarmObject'],
          width: '110px'
        }, {
          key: 'alarmAddress',
          label: this.$t('serverMonitor.table')['alarmAddress'],
          width: '94px'
        }, {
          key: 'locationInfo',
          label: this.$t('serverMonitor.table')['locationInfo'],
          width: '140px',
          showOverflowTooltip: true
        }, {
          key: 'alarmLevel',
          label: this.$t('serverMonitor.table')['alarmLevel'],
          formatter: 'Dictionary',
          formatterDic: this.select_alarmLevel,
          width: '84px'
        }, {
          key: 'alarmContent',
          label: this.$t('serverMonitor.table')['alarmContent']
        }, {
          key: 'alarmTime',
          label: this.$t('serverMonitor.table')['alarmTime'],
          width: '150px'
        }, {
          key: 'continueTime',
          label: this.$t('serverMonitor.table')['continueTime'],
          width: '74px'
        }, {
          key: 'charity',
          label: this.$t('serverMonitor.table')['charity'],
          width: '74px'
        }]
      },
      handle () {
        if (this.tableSelect.length === 0) {
          this.$message({
            message: this.$t('serverMonitor.selectTips'),
            type: 'warning'
          })
          return
        }
        let handleList = []
        this.tableSelect.map((item) => {
          handleList.push(item.id)
        })
        alarmQueryBiz.handle({ id: handleList }).then(() => {
          this.$message({
            message: this.$t('common.success'),
            type: 'success'
          })
          this.searchAlarm()
        })
      },
      async waitType () {
        await this.dGetDictionaryByCode('alarmType')
        this.select_alarmType = { ...this.dDictionary.alarmType }
        this.waitLevel()
      },
      async waitLevel () {
        await this.dGetDictionaryByCode('alarmLevel')
        this.select_alarmLevel = { ...this.dDictionary.alarmLevel }
        this.initTable()
        this.currentPage = 1
        this.perPageCount = 10
        this.searchAlarm()
      },
      searchAlarm () {
        let searchObj = {
          currentPage: this.currentPage,
          perPageCount: this.perPageCount,
          siteCode: this.$route.query.siteCode
        }
        Object.keys(this.alarmForm).map((item) => {
          if (this.alarmForm[item]) {
            searchObj[item] = this.alarmForm[item]
          }
        })
        alarmQueryBiz.query(searchObj).then((data) => {
          data.dataList.map((item) => {
            item.continueTime = TimeFormat.millisecondToDate(item.continueTime)
            item.alarmTime = TimeFormat.getFormatTime(item.alarmTime)
          })
          this.tData = data
        })
      },
      alarmSelect (val) {
        this.tableSelect = val
      },
      currentChange (val) {
        this.currentPage = val
        this.searchAlarm()
      },
      sizeChange (val) {
        this.currentPage = 1
        this.perPageCount = val
        this.searchAlarm()
      }
    },
    watch: {
      app (val) {
        this.$refs['alarmForm'].resetFields()
        this.alarmForm.alarmObject = val
        if (val) this.waitType()
      }
    }
  }
</script>

<style>

</style>